<template>
    <div>
        <div v-if="loading">
            <div>
                <div class="pull-left" style="margin-right: 15px;">
                    <div class="border-img" style="width: 80px">
                        <div class="loading-placeholder" style="width: 100%; height: 74px"></div>
                    </div>
                </div>
                <div class="pull-left">
                    <div>
                        <div class="loading-placeholder" style="width: 100px; height: 18px; margin-bottom: 4px"></div>
                        <div class="loading-placeholder" style="width: 120px; height: 18px; margin-bottom: 4px"></div>
                        <div class="loading-placeholder" style="width: 150px; height: 18px; margin-bottom: 4px"></div>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
        <div v-if="!loading && !property">
            O imóvel não pode ser carregado ou você não tem permissão para visualiza-lo(Referencia interna: {{ id }})...
        </div>
        <div v-if="!loading && property">
            <div>
                <div class="pull-left" v-if="property.photo" v-property-info :id="property.id" style="cursor: pointer">
                    <img class="border-img" v-bind:src="property.photo.thumbnails.small" style="max-width: 80px; margin-right: 15px;">
                </div>
                <div class="pull-left" v-if="!property.photo" v-property-info :id="property.id" style="cursor: pointer">
                    <div class="border-img" style="cursor: pointer; position: relative; width: 80px; height: 80px; margin-right: 15px;">
                        <div class="anchor-parent background-cover"
                             style="margin: 3px; background-image: url(/assets/images/imagem-nao-disponivel-media.png);"></div>
                    </div>
                </div>
                <div class="pull-left">
                    <div>
                        Cod. <b>{{ property.userCode }}</b>
                        <br>
                        <property-line :property="property" name="simple-description"></property-line>
                        <br>
                        <property-line :property="property" name="address"></property-line>
                    </div>
                    <div style="margin-top: 5px;">
                        <span class="timeline-link" v-if="property.latidude && property.longitude">
                            <a href="javascript:;" v-map-shadow :data="property">VER MAPA</a>
                            <span style="width: 10px; display: inline-block;"></span>
                        </span>
                    </div>
                    <div>
                        <slot name="extra"></slot>
                        <slot name="controls"></slot>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
    </div>
</template>
<script>
    // Loads properties in the future
    const R = require('ramda')

    const { searchClient, DebounceQueue } = require('sci/helpers')

    const queue = new DebounceQueue((ids) => {
        return searchClient
            .query({
                query: `
                    query ($request: PropertiesRequest!) {
                      result: properties(request: $request) {
                        total
                        totalUnfiltered
                        fromOffset
                        toOffset
                        remaining
                        totalOnPage
                        totalOfPages
                        currentPage
                        itemsPerPage
                        hasMore
                        items {
                          id
                          editable
                          deletable
                          id
                          code
                          userCode
                          draft
                          photos {
                            id
                            position
                            description
                            name
                            path
                            mime
                            size
                            width
                            height
                            url
                            thumbnails {
                              wmedium
                            }
                          }
                          photo {
                            id
                            position
                            description
                            name
                            path
                            mime
                            size
                            width
                            height
                            url
                            thumbnails {
                              wmedium
                              medium
                              small
                            }
                          }
                          videos {
                            id
                            url
                            thumbnail
                          }
                          statusInfo {
                            id
                            name
                          }
                          status
                          code
                          alternativeCode
                          typeInfo {
                            id
                            name
                          }
                          subtypeInfo {
                            id
                            name
                          }
                          street
                          streetNumber
                          complementary
                          neighborhood {
                            id
                            name
                          }
                          city {
                            id
                            name
                            state {
                              id
                              name
                              abbreviation
                            }
                          }
                          building {
                            id
                            name
                            type
                          }
                          condominiumName
                          sellPrice
                          rentPrice
                          dormCount
                          suitCount
                          carGarageCount
                          createdAt
                          updatedAt
                          totalArea
                          totalUsefulArea
                          forRent
                          forSale
                          forVacation
                          forLease
                        }
                      }
                    }
                `,
                variables: {
                    request: {
                        search: {
                            idOp: {
                                in: ids.map(id => parseInt(id, 10))
                            }
                        },
                        sort: {},
                        page: 1,
                        limit: 50
                    }
                }
            }).then((r) => {
                return R.pathOr(null, ['data', 'result', 'items'], r)
            })
    }, r => String(r.id))

    export default {
        components: {
            PropertyLine: require('components/property/Line.vue')
        },
        props: {
            id: {
                type: [String, Number],
                required: true
            }
        },
        data () {
            return {
                loading: true,
                property: null
            }
        },
        ready () {
            queue.load(this.id).then((r) => {
                this.loading = false
                this.property = r
            }).catch((ex) => {
                this.loading = false
            })
        }
    }
</script>


// WEBPACK FOOTER //
// DelayedProperty.vue?05ea33cc